import React from 'react';
import { Tag, Popover } from 'antd';

const BulkyTag = (props) => {

  const data = props.data
  const tag =  <Tag color='blue' style={{ margin: '0px 4px'}}>Bulky</Tag>

  if (!data) {
    return tag
  }

  const content = (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr'}}>
        <div style={{ fontWeight: 700 }}>Length (cm)</div><div>{data.length}</div>
        <div style={{ fontWeight: 700 }}>Width (cm)</div><div>{data.width}</div>
        <div style={{ fontWeight: 700 }}>Height (cm)</div><div>{data.height}</div>
        <div style={{ fontWeight: 700 }}>Weight (kg)</div><div>{data.weight}</div>
      </div>
      <div style={{ maxWidth: '150px', fontSize: '12px', marginTop: '4px'}}>Please raise a RFA to PIMS team if ths is wrong!</div>
    </div>
  );

  return (
    <Popover content={content} title="Shipping Details">
      {tag}
    </Popover>
  )
}

export default BulkyTag


// WEBPACK FOOTER //
// ./src/components/orders-v3/tags/bulky.js